<template lang="pug">
    Tabs.purchase-list.pagination
        el-card.contains-table(shadow="always")
            Shipping(id="sales-shipping" context="SALES")

</template>

<script>
import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'

import Shipping from '@/extensions/shop/pointOfSale/views/Shipping.vue'

import { usePosSetupStore, useSetupStore } from '@/stores'

export default {
    name: 'SalesShipping',
    components: {
        PropertyValue,
        Tabs,
        Shipping
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        stock: {
            get() {
                if (this.activeStock) return this.activeStock.name
                else return ""
            },
            set(value) {
                let activeStock = _.find(this.options.stock.items, stock => stock.name == value);
                this.posSetupStore.updateActiveStock(activeStock)
            }
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        activeStock() {
            return this.posSetupStore.activeStock;
        },
        options() {
            return this.posSetupStore.options;
        }
    },
    watch: {
        // The queue belongs to the selected store, so switching stores has to
        // refetch it - otherwise the previous store's work stays on screen.
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (!reload) return;

            this.initializePos('SALES');
        },
    },

    methods: {
        initializePos(context) {
            return this.posSetupStore.initialize(context);
        },
        setActiveStock(stock) {
            this.posSetupStore.setActiveStock(stock);
        }
    },
    mounted() {
        this.initializePos("SALES");
        this.$emit('focus-search')
    }
}
</script>

<style lang="sass">
#sales-shipping
    .scroll-box
        height: auto
        position: relative

body.sales-shipping
    aside, header.el-header
        display: block
    &.show-navigation
        aside, header.el-header
            display: block
</style>